import { lighten } from "@mui/material/styles";

const severityColors = theme => ({
  Green: {
    backgroundColor: "#92d050",
    color: theme.palette.getContrastText("#92d050"),
    "&:hover": {
      backgroundColor: lighten("#92d050", 0.1),
      color: theme.palette.getContrastText(lighten("#92d050", 0.1))
    }
  },
  Blue: {
    backgroundColor: "#00b0f0",
    color: "white",
    "&:hover": {
      backgroundColor: lighten("#00b0f0", 0.1),
      color: "white"
    }
  },
  YellowGreen: {
    backgroundColor: "rgb(202, 202, 40)",
    color: theme.palette.getContrastText("rgb(202, 202, 40)"),
    "&:hover": {
      backgroundColor: lighten("rgb(202, 202, 40)", 0.1),
      color: theme.palette.getContrastText(lighten("rgb(202, 202, 40)", 0.1))
    }
  },
  Yellow: {
    backgroundColor: "#ffc30b",
    color: theme.palette.getContrastText("#ffc30b"),
    "&:hover": {
      backgroundColor: lighten("#ffc30b", 0.1),
      color: theme.palette.getContrastText(lighten("#ffc30b", 0.1))
    }
  },
  Red: {
    backgroundColor: "#ff0000",
    color: theme.palette.getContrastText("#ff0000"),
    "&:hover": {
      backgroundColor: lighten("#ff0000", 0.1),
      color: theme.palette.getContrastText(lighten("#ff0000", 0.1))
    }
  }
});

export default severityColors;
